<template>
  <div class="product-suggestions">
    <div v-if="!loading" class="pb-5">
      <div v-if="coPurchases.length">
        <div class="font-weight-medium pa-3">{{ suggestionText }}</div>
        <v-slide-group show-arrows>
          <v-slide-item
            v-for="(item, i) in coPurchases"
            :key="i"
            v-slot:default="{ active, toggle }"
            class="mx-3 hover-zoom py-3"
            style="width: 170px; cursor: pointer"
          >
          
            <div
              v-if="item.productDetails"
              @click="goToProductDetails(item)"
              class="font-weight-medium text-center d-flex flex-column justify-space-between fill-height"
              style=" position: relative"
            >
            <v-chip
                style="color: white"
                color="#ea412a"
                class="product-discount-tag"
                label
                v-if="item.productDetails.discounts.length && productDiscount(item)"
                >
                {{productDiscount(item)}}%
            </v-chip>
            <v-chip
                style="color: white"
                color="#ea412a"
                class="product-discount-tag"
                label
                v-if="item.bestCampaign && item.bestCampaign.PromotionType == 4"
                >
                    <span v-if="item.bestCampaign.BenefitRule == 1">{{item.bestCampaign.BenefitQty}} for {{item.bestCampaign.BenefitValue1}}</span>
                    <span v-if="item.bestCampaign.BenefitRule == 2">{{item.bestCampaign.BenefitQty}} for kr {{item.bestCampaign.BenefitValue1 | currency()}}</span>
            </v-chip>
              <div>
                <v-img
                  :src="item.imgUrl"
                  class="mx-auto"
                  height="100"
                  width="100"
                  lazy-src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8/OlTCAAI5AMtwFOAFgAAAABJRU5ErkJggg=="
                />
              </div>
              <div>
                <div class="pl-2" style="white-space: pre-wrap; text-align: left;">
                  {{ item.title }}
                </div>
              </div>
              <div
                class="font-weight-regular pt-3"
                style="font-size: 12px; white-space: pre-wrap; text-align: left;"
              >
                {{ item.brandName }} / {{ item.serieName }}
              </div>
              <div class="mt-auto pt-3">
                <div>
                  <span class="font-weight-regular">kr</span>
                  <span class="title">{{
                    item.productDetails.price | currency(2, 2)
                  }}</span>
                </div>
                <div>
                  <add-to-cart-click-and-collect
                    class="suggested__product__btn"
                    :product="item"
                    :details="false"
                  />
                </div>
              </div>
            </div>
          </v-slide-item>
        </v-slide-group>
      </div>
    </div>
    <div v-else class="mx-auto mt-8 text-center">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </div>
  </div>
</template>

<script>
import webshopMixins from "@/components/webshop/cart/webshop.mixins";
import AddToCartClickAndCollect from "./AddToCartClickAndCollect";
import { waitFor } from "vue-wait";

export default {
  name: "product-suggestions",
  components: { AddToCartClickAndCollect },
  mixins: [webshopMixins],
  props: ["suggestionText", "suggestionsFor", "static"],
  data() {
    return {
      windowSize: { x: window.innerWidth, y: window.innerHeight },
    };
  },
  methods: {
    GetCoPurchases() {
      if (!this.selectedProduct) return;
      waitFor(`loading webshopCore GetCoPurchases`, async function() {
        await this.$store.dispatch("webshopCore/getCoPurchases", {
          productIds: [
            {
              productGuid: this.selectedProduct.id,
              productId: this.selectedProduct.odinProductId,
            },
          ],
          count: 50,
          chainId: this.currentChainId,
          applicationNumber: 5,
        });
      }).apply(this);
    },
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },
    productDiscount(product){
      return Math.round(((product.productDetails.price- product.salePrice)/product.productDetails.price)*100)
    }
  },
  computed: {
    coPurchases() {
      return this.$store.getters["webshopCore/get"]('coPurchases');
    },

    loading() {
      return this.$wait.is("loading webshopCore GetCoPurchases");
    },
  },
  watch: {
    selectedProduct() {
      if (!this.static) this.GetCoPurchases();
    },
  },
  created() {
    this.GetCoPurchases();
  },
};
</script>

<style lang="scss" scoped>
.suggested__product__btn::v-deep {
  .v-btn {
    // padding: 0px 0px !important
  }
}
.v-slide-group::v-deep {
  .v-slide-group__content {
    place-content: center;
  }
}

.product-suggestions::v-deep {
  .v-btn {
    // padding: 18px 15px !important;
    height: 42px !important;
  }
}

.product-discount-tag{
    position: absolute;
    top: 0px;
    left: 0px;
    color: #FFFFFF;
    z-index: 1;
}
</style>
